import { listOutbox, removeOutbox, markOutboxFailure } from './webOutbox';
import { request } from '../api/http';

async function flushOne(item: any) {
  switch (item.kind) {
    case 'quest_log':
      await request(`/quests/${encodeURIComponent(String(item.payload.questId))}/logs`, {
        method: 'POST',
        auth: true,
        body: item.payload.body,
      });
      return true;

    case 'category_pref':
      await request('/me/preferences/category', {
        method: 'POST',
        auth: true,
        body: item.payload,
      });
      return true;

    case 'subcategory_pref':
      await request('/me/preferences/subcategory', {
        method: 'POST',
        auth: true,
        body: item.payload,
      });
      return true;

    case 'message_send':
      await request('/messages/send-e2ee', {
        method: 'POST',
        auth: true,
        body: item.payload,
      });
      return true;

    case 'quest_pick':
      await request('/quests/pick', {
        method: 'POST',
        auth: true,
        body: item.payload,
      });
      return true;

    default:
      return false;
  }
}

export async function flushWebOutbox() {
  const items = await listOutbox(Date.now());
  if (!items.length) return;

  for (const item of items) {
    try {
      const ok = await flushOne(item);
      if (ok) {
        await removeOutbox(item.id);
      } else {
        break;
      }
    } catch (e: any) {
      await markOutboxFailure(item.id, e?.message || 'sync_failed');
      break;
    }
  }
}
